// 提交申请
const applyUrl = `/gateway/hc-health/miniapi/safetyEquipment/apply`;
//获取区级联动接口
const areaLinkUrl = `/gateway/hc-space/space/getSpaceLinkList`;
// 获取剩余可申请设备数量
const getResidueSumsUrl = `/gateway/hc-health/miniapi/safetyEquipment/getResidueSums`;
export { applyUrl, areaLinkUrl, getResidueSumsUrl };
